import styled, { css } from 'styled-components'
import { Transition, breakpoints } from 'utils/constants'

export const Logo = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 12px;
  height: ${({ $height }) => `${$height}px`};
  width: ${({ $width }) => `${$width}px`};
  z-index: 3;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    opacity: ${({ $isLoaded }) => ($isLoaded ? 1 : 0)};
    transition: opacity ${Transition.ms300};
  }

  ${({ $isUploader }) =>
    $isUploader &&
    css`
      cursor: pointer;

      &:focus {
        outline-color: var(--p-blue-500);
      }

      &:hover::after,
      &:focus::after,
      &.is-dragging::after {
        opacity: 1;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: rgba(48, 65, 86, 0.45);
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg transform='translate(-636 -364)'%3E%3Crect width='24' height='24' transform='translate(636 364)' fill='none' /%3E%3Cpath d='M-18999-3383a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h3v-2a1,1,0,0,1,1-1h6a.993.993,0,0,1,1,1v2h3a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2Z' transform='translate(19640 3766)' fill='none' stroke='%23fff' stroke-width='1.5' /%3E%3Ccircle cx='3' cy='3' r='3' transform='translate(645 373)' fill='none' stroke='%23fff' stroke-width='1.5' /%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
        opacity: 0;
        transition: opacity ${Transition.ms300};
      }
    `}

  @media ${breakpoints.mobileMax} {
    margin: 0 20px 0 0;
  }
`

export const Letter = styled.div`
  font-size: 22px;
  text-transform: uppercase;
  display: flex;
  height: ${({ $height }) => `${$height}px`};
  width: ${({ $width }) => `${$width}px`};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--p-neutral-100);
  background-color: var(--p-blue-500);
  margin-bottom: 12px;

  ${({ $isUploader }) =>
    $isUploader &&
    css`
      cursor: pointer;
      overflow: hidden;
      position: relative;

      &:focus {
        outline-color: var(--p-blue-500);
      }

      &:hover::after,
      &:focus::after,
      &.is-dragging::after {
        opacity: 1;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: var(--p-blue-750-45);
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg transform='translate(-636 -364)'%3E%3Crect width='24' height='24' transform='translate(636 364)' fill='none' /%3E%3Cpath d='M-18999-3383a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h3v-2a1,1,0,0,1,1-1h6a.993.993,0,0,1,1,1v2h3a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2Z' transform='translate(19640 3766)' fill='none' stroke='%23fff' stroke-width='1.5' /%3E%3Ccircle cx='3' cy='3' r='3' transform='translate(645 373)' fill='none' stroke='%23fff' stroke-width='1.5' /%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
        opacity: 0;
        transition: opacity ${Transition.ms300};
      }
    `}
  @media ${breakpoints.mobileMax} {
    margin: 0 20px 0 0;
  }
`
